export default "__VITE_ASSET__f0d358f2__"